package demos.counter

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign

const val COUNTER_SIMPLE = "a6d237867c49c06a46bb369524d8b30039739b67"

@Composable
fun CounterSimple() {

    var count by remember { mutableStateOf(0) }

    Column (
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        CounterButton("+") { count++ }

        Text(
            "$count",
            style = MaterialTheme.typography.h3,
            textAlign = TextAlign.Center,
        )

        CounterButton("-") { count-- }
    }
}